<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="合作伙伴"
      third-bread="合作伙伴修改"
      first-url="/user/quality"
      second-url="/user/partner"
      title-name="合作伙伴修改"
    ></user-detail-title>
    <user-detail-base style="width: 60%">
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="公司名称">
          <el-input v-model="Clist.name" :placeholder="LookData.name"></el-input>
        </el-form-item>
        <el-form-item label="公司logo">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文字描述">
          <el-input v-model="Clist.description" type="textarea" :row="3" :placeholder="LookData.description"></el-input>
        </el-form-item>
        <el-button @click="handleChange">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "PartnerChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
        MenuTree:null,
        defaultProps:{
          children: 'childClassify',
          label: 'name'
        },
        Clist: {
          'id':this.$route.params.id,
          'name':null,
          'logoAddress':null,
          'description':null,
        },//表示Update添加的数据
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetUrlList(file){
        this.Clist.logoAddress=file.data;
      },
      GetLookData(id){
        this.$axios.get('/api/cooperative/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      },
      handleChange(){
        if (this.Clist.name || this.Clist.description ||this.Clist.logoAddress){
          this.$axios.post('/api/cooperative/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.Clist= {
                'id':this.$route.params.id,
                'name':null,
                'logoAddress':null,
                'description':null,
              }//表示Add添加的数据,
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('请至少填写一项上传')
        }
      }
    },
  }
</script>

<style scoped>

</style>